//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, postAction } from '@/api/manage';
export default {
  name: 'RoleList',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      description: '角色管理页面',
      visible: false,
      // 查询条件
      queryParam: {
        roleName: ''
      },
      dataSourceAll: [],
      // 表头
      columns: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '角色名称',
        align: 'center',
        dataIndex: 'roleName'
      }, {
        title: '角色编码',
        align: 'center',
        dataIndex: 'roleCode'
      }, {
        title: '备注',
        align: 'center',
        dataIndex: 'description'
      }],
      model: {},
      roleBeforeList: [],
      url: {
        list: '/sys/role/list',
        permission: '/sys/permission/queryRole/',
        addPer: '/sys/permission/addRole'
      }
    };
  },
  computed: {},
  methods: {
    edit: function edit(record) {
      var _this = this;

      this.visible = true;
      this.roleBeforeList = [];
      this.model = Object.assign({}, record); //获取已经有的权限角色

      getAction(this.url.permission + this.model.permissionId).then(function (res) {
        if (res.success) {
          _this.roleBeforeList = res.result;
          _this.selectedRowKeys = res.result;
        }
      }); //获取所有权限角色

      var params = {
        pageNo: 1,
        pageSize: 10000
      };
      getAction(this.url.list, params).then(function (res) {
        if (res.success) {
          _this.dataSourceAll = res.result.records;
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.close();
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    handleSelect: function handleSelect() {
      var _this2 = this;

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }

      var that = this;
      var addRole = this.selectedRowKeys.filter(function (val) {
        return that.roleBeforeList.indexOf(val) == -1;
      });
      var delRole = this.roleBeforeList.filter(function (val) {
        return that.selectedRowKeys.indexOf(val) == -1;
      });
      var params = {
        addRole: addRole.join(','),
        delRole: delRole.join(','),
        permissionId: this.model.permissionId
      };
      postAction(this.url.addPer, params).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loading = false;

          _this2.$emit('ok');

          _this2.handleCancel();
        } else {
          that.$message.error(res.message);
          that.loading = false;
        }
      });
    }
  }
};